import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable, map } from 'rxjs';
import { ToastService } from 'src/app/_metronic/shared/components/toast/toast.service';
import { BaseService } from 'src/app/services/base.service';
import { ENDPOINT } from 'src/app/types/constants/endpoint.constant';
import {
  IApiResponseDetail,
  IApiResponseList,
  IDetailResponse,
  IInspectionDetail,
  IListResponse,
  IParamsTableData
} from 'src/app/types/interfaces/common.interface';

@Injectable({
  providedIn: 'root',
})
export class InspectionCompanyService extends BaseService {
  constructor(protected http: HttpClient, private toast: ToastService) {
    super(http);
  }

  getInspectionCompanyList(
    params: IParamsTableData
  ): Observable<IListResponse<IInspectionDetail>['list']> {
    return this.getRequest(
      ENDPOINT.INSPECTION_COMPANY,
      params,
    ).pipe(
      map((res: IApiResponseList<IInspectionDetail>) => {
        return res.response_output.list;
      })
    );
  }

  checkFuelUnitId(inspectionId: string, fuelUnitId: string): Observable<boolean> {

    return this.getRequest(ENDPOINT.INSPECTION_CHECK_FUEL_ID(inspectionId, fuelUnitId), null, 'spinneroff').pipe(
      map((res: IApiResponseDetail<boolean>) => {
        return res.response_output.detail;
      })
    );
  }

  deleteMedia(ids: number[]) {
    return this.deleteRequest(ENDPOINT.INSPECTION_DELETE_MEDIA, {
      file_upload_ids: ids.toString()
    });
  }

  getDetail(
    id: string
  ): Observable<IDetailResponse<IInspectionDetail>['detail']> {
    return this.getRequest(ENDPOINT.INSPECTION_COMPANY + `/${id}`).pipe(
      map((res: IApiResponseDetail<IInspectionDetail>) => {
        const microsite = res.response_output.detail.microsite;
        microsite.site_ready_to_inspect_date =
          new Date(microsite.site_ready_to_inspect_date) || null;
        return res.response_output.detail;
      })
    );
  }

  rejectInspection(id: string, payload: any): Observable<IApiResponseDetail<any>> {
    return this.postRequest(ENDPOINT.INSPECTION_COMPANY + `/${id}/reject`, payload);
  }

  continueInspection(id: string): Observable<IApiResponseDetail<any>> {
    return this.putRequest(
      ENDPOINT.INSPECTION_COMPANY + `/${id}/continue`
    );
  }

  updateInspection(id: string, payload: any): Observable<IApiResponseDetail<any>> {
    return this.putRequest(
      ENDPOINT.INSPECTION_COMPANY + `/${id}`,
      payload
    );
  }

  downloadList(
    params: IParamsTableData
  ) {
    return this.getRequestDownloadFile(ENDPOINT.INSPECTION_COMPANY_TABLE_DOWNLOAD,params);
  }
}
